$(document).ready(function() {

  if ($("#paymentPlans").length) {

    var stripeKey = $("#stripeKey").val();
    var stripeImage = $(".stripe-icon:first").val();
    var handler = StripeCheckout.configure({
      key: stripeKey,
      image: stripeImage,
      locale: 'auto',
      token: function(token, args) {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.

        var planID = $("#selected-plan").val();

        $("#token-"+planID).val(JSON.stringify(token));
        $("#args-"+planID).val(JSON.stringify(args));

        $("#planPurchase-"+planID).submit();

      }
    });

    $(".plans-button").each(function(){
      //console.log($(this));

      $(this).click(function(e) {

        // Track chosen plan
        $("#selected-plan").val($(this).siblings(".plan-id:first").val())

        // Open Checkout with further options:
        handler.open({
          name: 'Leaderboard by Setwise Tecnology, LLC',
          description: $(this).siblings(".plan-description:first").val(),
          amount: $(this).siblings(".plan-price:first").val()*100,
          zipCode: true,
          billingAddress: true,
          email: $(this).siblings(".plan-email:first").val()
        });
        e.preventDefault();
      });

    });

    //Close Checkout on page navigation:
    window.addEventListener('popstate', function() {
      handler.close();
    });

  }

});
